import useMediaQuery from './useMediaQuery';

const breakpoints = {
  mobile: 768,
  tablet: 1024,
  desktop: 1441,
};

const devices = {
  mobile: `(max-width: ${breakpoints.mobile}px)`,
  tablet: `(min-width: ${breakpoints.mobile}px) and (max-width: ${breakpoints.tablet}px)`,
  desktop: `(min-width: ${breakpoints.tablet}px)`,
  largeDesktop: `(min-width: ${breakpoints.desktop}px)`,
};

export default function useDeviceInfo() {
  const isMobile = useMediaQuery(devices.mobile);
  const isDesktop = useMediaQuery(devices.desktop);
  return { isMobile, isDesktop };
}
